<script setup lang="ts">
import LogoIconFramed from '~/components/ui/LogoIconFramed/LogoIconFramed.vue'
import VCard from '~/components/ui/VCard.vue'

type Props = {
  link?: string
  title?: string
  description?: string
  linkTarget?: '_blank' | '_self'
}
type Emits = {
  click: [event: MouseEvent]
}
type Slots = {
  title(): any
  description(): any
}

withDefaults(defineProps<Props>(), {
  link: '',
  title: '',
  description: '',
  linkTarget: '_blank',
})
const emit = defineEmits<Emits>()
defineSlots<Slots>()
</script>

<template>
  <a
    :href="link"
    :target="linkTarget"
    rel="noopener"
    @click="emit('click', $event)"
  >
    <VCard
      class="!tw-bg-orange-100 tw-shadow-round hover:tw-shadow-[color:rgba(51,51,51,0.15)]"
      padding="4"
    >
      <div class="tw-flex">
        <LogoIconFramed size="lg" class="tw-mr-sm 375:tw-mr-lg" />
        <div class="tw-flex tw-flex-col">
          <span
            class="tw-text-body-sm tw-font-bold tw-text-orange-500 md:tw-text-body 375:tw-mb-2"
          >
            <slot name="title">{{ title }}</slot>
          </span>
          <span
            class="tw-text-body-sm tw-hidden tw-overflow-hidden tw-text-discrete2 375:tw-line-clamp-3"
          >
            <slot name="description">{{ description }}</slot>
          </span>
        </div>
      </div>
      <span
        class="tw-text-body-sm tw-mt-2 tw-line-clamp-3 tw-overflow-hidden tw-text-discrete2 375:tw-hidden"
      >
        <slot name="description">{{ description }}</slot>
      </span>
    </VCard>
  </a>
</template>
